import { render, staticRenderFns } from "./ModSMHI.vue?vue&type=template&id=471833b5"
import script from "./ModSMHI.vue?vue&type=script&lang=js"
export * from "./ModSMHI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports